import React from "react"
import { View, Pagination } from "react-ame-components"
import ShowCase from "../components/Showcase"

export class PaginationExample extends React.Component {
  state = {
    pages: 10,
    currentPage: 1,
    pagesContent: [
      { colorPage: "primary", textPage: "Primary color" },
      { colorPage: "secondary", textPage: "Secondary color" },
      { colorPage: "neutral-500", textPage: "Neutral 500 color" },
      { colorPage: "primary-700", textPage: "Primary 700 color" },
      { colorPage: "secondary-700", textPage: "Secondary 700 color" },
      { colorPage: "positive-700", textPage: "Positive 700 color" },
      { colorPage: "warning-700", textPage: "Warning 700 color" },
      { colorPage: "negative-700", textPage: "Negative 700 color" },
      { colorPage: "support-01", textPage: "Support 01 color" },
      { colorPage: "support-03", textPage: "Support 02 color" },
    ],
  }

  render() {
    return (
      <ShowCase
        centerGrid
        title="Componente Pagination"
        description="Componente perfeito para escolher opções rápidas">
        <View
          direction="column"
          align="center"
          justify="center">
          <View
            width="80%"
            height="320px"
            align="center"
            justify="center"
            backgroundColor={
              this.state.pagesContent[this.state.currentPage - 1].colorPage
            }>
            {this.state.pagesContent[this.state.currentPage - 1].textPage}
          </View>
          <View height="16px" />
          <Pagination
            currentPage={this.state.currentPage}
            pages={this.state.pages}
            onClick={page => this.setState({ currentPage: page })}
            showFirstButton
            showLastButton
            pageRange={10}
          />
        </View>
      </ShowCase>
    )
  }
}
